import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddedToList = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18.2 16.27",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6.70885 16.2657C6.40885 16.2657 6.12885 16.1457 5.91885 15.9357L0.308847 10.1457C-0.111153 9.70568 -0.101149 9.01568 0.328851 8.58568C0.758851 8.15568 1.45885 8.1757 1.88885 8.6057L6.59885 13.4657L16.2189 0.445724C16.5789 -0.0442756 17.2689 -0.144317 17.7589 0.215683C18.2489 0.575683 18.3488 1.26572 17.9888 1.75572L7.59885 15.8257C7.40885 16.0857 7.10885 16.2457 6.78885 16.2657C6.76885 16.2657 6.73885 16.2657 6.71885 16.2657H6.70885Z"
	})
});
export { SvgAddedToList as ReactComponent };
